import React, { useState } from 'react'
import { message, Form, AutoComplete, Input, Row, Col, Divider } from 'antd'
import IntlMessages from '../util/IntlMessages'
import ds from '../Services/DataServices'
import { useSelector, useDispatch } from 'react-redux'
import {
  loadCustomerSearchData,
  loadCustomerSearchDataForHistory
} from '../appRedux/actions/Sell'
import { loadHistoryModalCusSearch } from '../appRedux/actions/CommonData'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../constants/IndexDBData'
import { getDecryptID, isEmptyObject } from '../appRedux/actions'
import { GetIndexDBDataByTableName } from '../appRedux/actions/IndexDBActions'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const SearchCustomer = props => {
  const screen = props.screen
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  // const getCustomerSearchData = useSelector(
  //   ({ Sell }) => Sell.customerSearchData
  // );

  const [options, setOptions] = React.useState([])
  const [getSearchCustomer, setSearchCustomer] = useState([])
  const [asd, qwe] = useState('')

  // React.useEffect(() => {
  //   if (Object.keys(getCustomerSearchData).length === 0) {
  //     // qwe("");
  //     form.resetFields();
  //     // form.resetFields("ProductSearch");
  //     // form.resetFields("ASD");
  //     // form.resetFields(["ProductSearch"]);
  //     // form.resetFields(["ASD"]);
  //     // form.setFieldsValue({ ProductSearch: "" });
  //     // form.setFieldsValue({ ASD: "" });
  //   }
  // }, [getCustomerSearchData]);

  const onSelect = value => {
    if (getSearchCustomer && getSearchCustomer.length > 0) {
      const customer = getSearchCustomer.filter(
        a => a.customerFirstName + ' ' + a.customerLastName == value
      )
      if (customer.length > 0) {
        let cusForStore = customer[0]
        if (screen == 'SellScreen' && cusForStore.customerFirstName) {
          const firstLetter = cusForStore.customerFirstName
            ? cusForStore.customerFirstName.charAt(0)
            : 'x'
          const secondLetter = cusForStore.customerLastName
            ? cusForStore.customerLastName.charAt(0)
            : 'y'
          const lettersName =
            firstLetter.toUpperCase() + secondLetter.toUpperCase()
          cusForStore.letterName = lettersName
          dispatch(loadCustomerSearchData(cusForStore))
        } else if (screen == 'SaleHistory') {
          dispatch(loadCustomerSearchDataForHistory(cusForStore))
        } else if (screen == 'HistoryModal') {
          let firstLetter = cusForStore.customerFirstName
            ? cusForStore.customerFirstName.charAt(0)
            : 'x'
          let secondLetter = cusForStore.customerLastName
            ? cusForStore.customerLastName.charAt(0)
            : 'y'
          let lettersName =
            firstLetter.toUpperCase() + secondLetter.toUpperCase()
          let cusData = {
            key: cusForStore.customerSId,
            customerName:
              cusForStore.customerFirstName +
              ' ' +
              cusForStore.customerLastName,
            customerCode: cusForStore.customerCode,
            groupName: cusForStore.groupName,
            letterName: lettersName
          }
          dispatch(loadHistoryModalCusSearch(cusData))
        }
      }
    }
    form.resetFields()
  }

  const handleSearch = async value => {
    if (value.length > 1) {
      let searchCustomer = {
        data: {
          msgCode: '',
          msgDescription: ''
        }
      }
      let body = {
        keys: value,
        GroupKey: ''
      }

      if (isOnline) {
        await ds
          .getCustomerSearchService(body)
          .then(response => {
            searchCustomer.data = response.data
            buildCustomerSearch(searchCustomer)
          })
          .catch(e => {})
      } else {
        if (screen == 'SellScreen') {
          searchCustomer = await getIndexDBCustomers(searchCustomer, value)
        }
      }
    } else {
      setOptions([])
      setSearchCustomer([])
    }
  }

  function buildCustomerSearch (searchCustomer) {
    if (
      searchCustomer &&
      !isEmptyObject(searchCustomer) &&
      searchCustomer.data
    ) {
      let nameArray = []
      if (searchCustomer.data.msgCode == 'GENERAL_SUCCESS') {
        if (searchCustomer.data.data.length > 0) {
          setSearchCustomer(getSearchCustomer.concat(searchCustomer.data.data))
          nameArray = searchCustomer.data.data.map(data => {
            const category =
              data.customerFirstName + ' ' + data.customerLastName
            const groupName = data.groupName ? data.groupName : ''
            const code = data.customerCode ? data.customerCode : ''
            // const id = names.customerSId;
            return {
              value: category,
              label: (
                <>
                  <div>
                    <Row style={{ textAlign: 'left' }}>
                      <Col span={12} lg={24} md={24} sm={24} xs={24}>
                        <strong>{category}</strong>
                        <span
                          style={{ marginLeft: '5px' }}
                          className='vd-flag sm:hidden'
                        >
                          {groupName}
                        </span>
                      </Col>
                    </Row>
                    <Row style={{ textAlgin: 'left' }}>
                      <Col span={12} lg={12} md={12} sm={12} xs={24}>
                        <span className='font-size-smaller'>
                          <IntlMessages id='customerz.search.code' />:
                          <strong
                            style={{ color: '#40a9ff' }}
                          >{` ${code}`}</strong>
                        </span>
                      </Col>
                    </Row>
                    <Divider />
                  </div>
                </>
              )
            }
          })
        }
        setOptions(nameArray)
      }

      if (searchCustomer.data.msgCode == 'GENERAL_ERROR') {
        // message.error(searchCustomer.data.msgDescription);
        message.info('Kindly report, Server is down')
      }
    }
  }

  async function getIndexDBCustomers (body, value) {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.CUSTOMERS
    )
    data
      .then(e => {
        if (e && e.length > 0) {
          if (value) {
            const val = value.toLowerCase()
            const customers = e.filter(
              q =>
                q.firstName.toLowerCase().includes(val) ||
                q.lastName.toLowerCase().includes(val)
            )
            if (customers && customers.length > 0) {
              body.data.data = customers
              body.data.msgCode = 'GENERAL_SUCCESS'
              getIndexDBCustomerGroups(body)
            }
          }
        }
      })
      .catch(e => {
        console.log(
          'INDEX_DB_ERROR -> getIndexDBCustomers, index api call CUSTOMERS -->',
          e
        )
      })
  }

  async function getIndexDBCustomerGroups (body) {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.CUSTOMERGROUPS
    )
    data
      .then(e => {
        let cusGroups = []
        if (e && e.length > 0) {
          cusGroups = e
        }
        buildCusBody(body, cusGroups)
      })
      .catch(e => {
        console.log(
          'INDEX_DB_ERROR -> getIndexDBCustomerGroups, index api call CUSTOMERGROUPS -->',
          e
        )
      })
  }

  function buildCusBody (values, groups) {
    const cusBodies = []
    values.data.data.map(ww => {
      const grpName =
        ww.customerGroupID &&
        groups.filter(
          r => r.customerGroupId == getDecryptID(ww.customerGroupID)
        ).length > 0
          ? groups.filter(
              r => r.customerGroupId == getDecryptID(ww.customerGroupID)
            )[0].customerGroupName
          : ''
      cusBodies.push({
        customerFirstName: ww && ww.firstName ? ww.firstName : '',
        customerLastName: ww && ww.lastName ? ww.lastName : '',
        groupName: ww.customerGroupID == '' ? 'All Customers' : grpName,
        customerCode: ww && ww.customerCode ? ww.customerCode : '',
        customerSId: `${ww.customerProfileId}&&_9efa-1ea9-4faf-88ed-a48e65b46643`,
        customerGroupId: `${
          ww.customerGroupID == '' ? '0' : ww.customerGroupID
        }&&_9efa-1ea9-4faf-88ed-a48e65b46643`
      })
    })

    values.data.data = cusBodies
    buildCustomerSearch(values)
  }

  return (
    <>
      {screen == 'SellScreen' && (
        <div className='add-customer-div div-flow'>
          <Form.Item
            className='mb-0'
            name='ProductSearch'
          >
            <AutoComplete
              className='certain-category-search'
              dropdownClassName='certain-category-search-dropdown'
              dropdownMatchSelectWidth={true}
              allowClear={true}
              autoFocus={false}
              notFoundContent={<IntlMessages id='customerz.search.notfound' />}
              options={options}
              onSelect={onSelect}
              onSearch={handleSearch}
            >
              <Input className='Add-Customer-bar'
                placeholder='Add a customer'
                prefix={<i className='icon icon-user' />}
              />
            </AutoComplete>
          </Form.Item>
        </div>
      )}

      {screen == 'SaleHistory' && (
        <div className='gx-form-row0'>
          <Form.Item
            className='ant-form-item-label-custom'
            name={`CustomerSaleHistory`}
            label={<IntlMessages id='sell.salehistory.col2' />}
          >
            <AutoComplete
              className='certain-category-search'
              dropdownClassName='certain-category-search-dropdown'
              dropdownMatchSelectWidth={true}
              allowClear={true}
              autoFocus={false}
              notFoundContent={<IntlMessages id='customerz.search.notfound' />}
              options={options}
              onSelect={onSelect}
              onSearch={handleSearch}
              onClear={() => dispatch(loadCustomerSearchDataForHistory({}))}
            >
              <Input
                // className="custom-pd-10"
                size='large'
                placeholder='Name of a customer'
                // prefix={<i className="icon icon-user" />}
              />
            </AutoComplete>
          </Form.Item>
        </div>
      )}

      {screen == 'HistoryModal' && (
        <Form.Item name='customers'>
          <AutoComplete
            className='certain-category-search'
            dropdownClassName='certain-category-search-dropdown'
            dropdownMatchSelectWidth={true}
            allowClear={true}
            autoFocus={false}
            notFoundContent={<IntlMessages id='customerz.search.notfound' />}
            options={options}
            onSelect={onSelect}
            onSearch={handleSearch}
            // onClear={() => dispatch(loadCustomerSearchDataForHistory({}))}
          >
            <Input
              // className="custom-pd-10"
              size='large'
              placeholder='Name of a customer'
              // prefix={<i className="icon icon-user" />}
            />
          </AutoComplete>
        </Form.Item>
      )}
    </>
  )
}

export default SearchCustomer
